import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<LegacyLicenseDisplay\n  @singleLicense={{this.license}}\n/>",{ moduleName: "cpc-license-manager/pods/legacy-license/template.hbs" })